
import { getFetch } from '../fetch';

import { apiConfig } from '../config';

export function getTime(timeToDiff?: number) {
    const { apiGetTime } = apiConfig.getStaticUrls();

    return getFetch(apiGetTime, { time: timeToDiff });
}
